// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'salary-packages/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/archived-team-member-salary-packages.vue'),
        name: 'human-resource.team-member-salary-packages.archived-team-member-salary-packages',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.update-team-member-salary-package',
        },
    },
    {
        path: 'salary-packages/archive/:packageId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/archived-team-member-salary-package/[id].vue'),
        name: 'human-resource.team-member-salary-packages.view-archived-team-member-salary-package',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.update-team-member-salary-package',
        },
    },
    {
        path: 'salary-packages',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/team-member-salary-packages.vue'),
        name: 'human-resource.team-member-salary-packages.search-team-member-salary-packages',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.view-team-member-salary-packages',
        },
    },
    {
        path: 'salary-packages/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/team-member-salary-package/new.vue'),
        name: 'human-resource.team-member-salary-packages.create-team-member-salary-package',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.create-team-member-salary-package',
        },
    },
    {
        path: 'salary-packages/:packageId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/team-member-salary-package/[id].vue'),
        name: 'human-resource.team-member-salary-packages.view-team-member-salary-package',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.view-team-member-salary-packages',
        },
    },
    {
        path: 'salary-packages/:packageId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-salary-packages" */ '@/pages/[organisation]/hr/team-member-salary-packages/team-member-salary-package/[id]/edit.vue'),
        name: 'human-resource.team-member-salary-packages.update-team-member-salary-package',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.salary-package.update-team-member-salary-package',
        },
    },
];
